const InboxTypes = {
  INBOX: 'Inbox',
  ARCHIVE: 'Archive'
};
export default InboxTypes;
//# sourceMappingURL=inboxTypes.enum.js.map